/**
 * Photo numbers as the PDF prints them: one sequence through the whole report,
 * step after step, in display order — so "voir photo n°7" written in the text
 * points at the same picture on screen and on paper.
 *
 * Photos still waiting to upload get no number yet: the server decides their
 * place, and a number that later shifts would be worse than none.
 */
export function photoNumbers(steps) {
  const numbers = new Map();
  let n = 0;
  [...(steps || [])]
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .forEach((step) => {
      (step.images || []).forEach((img) => {
        if (img._pendingUpload || img._uploading) return;
        n += 1;
        numbers.set(img.id, n);
      });
    });
  return numbers;
}
